
<div style="display : flex; gap : 1rem; align-items: end;">
  <dx-text-box
    width="300" 
    [label]="title"
    labelMode="static"
    [value]="apercuTri"
    [readOnly]="true"
    [disabled]="disabled">
  </dx-text-box>
  <dx-button 
    icon="edit"
    type="default"
    [disabled]="disabled"
    (onClick)="displayPopup()">
  </dx-button>
</div>
<dx-popup
  [(visible)]="popupVisible"
  [width]="600"
  [height]="450"
  [showTitle]="true"
  [title]="title"
  (onHiding)="popupVisible=false">
  
  <!-- Critères disponibles -->
  <div style="margin-bottom: 20px;">
    <h4>Critères disponibles :</h4>
    <div class="propriete" *ngFor="let prop of proprietesDisponibles">
      <span>{{ prop.propertyDisplay }}</span>
      <dx-button 
        icon="plus"
        type="default"
        (onClick)="ajouterCritere(prop)">
      </dx-button>
    </div>
    <div *ngIf="proprietesDisponibles.length === 0" style="color: #999; font-style: italic;">
      Tous les critères sont déjà utilisés
    </div>
  </div>

  <!-- Configuration actuelle -->
  <div>
    <h4>Configuration du tri :</h4>
    <div *ngIf="triConfiguration.length === 0" style="color: #999; font-style: italic; padding: 20px; text-align: center;">
      Aucun critère configuré
    </div>
      <dx-sortable
      *ngIf="triConfiguration.length > 0"
      [data]="triConfiguration"
      group="sortCriteria"
      [allowDropInsideItem]="false"
      [allowReordering]="true"
      itemOrientation="vertical"
      dragDirection="vertical"
      (onReorder)="onReorderCriteres($event)">
      <div *ngFor="let config of triConfiguration; let i = index" 
        class="sort">
        
        <!-- Ordre -->
        <span style="font-weight: bold; width: 30px;">{{ i + 1 }}.</span>
        
        <!-- Propriété -->
        <span style="flex: 1;">{{ getPropertyDisplay(config.propertyName) }}</span>
        
        <!-- Direction -->
        <dx-select-box
        *ngIf="getPropertyDataType(config.propertyName) == 'string' || getPropertyDataType(config.propertyName) == undefined"
          [(value)]="config.direction"
          [items]="directionsStandard"                                                                                 
          valueExpr="value"
          displayExpr="libelle"
          [width]="160">
        </dx-select-box>
  
        <dx-select-box
        *ngIf="getPropertyDataType(config.propertyName) == 'date'"
          [(value)]="config.direction"
          [items]="directionsDates"                                                                                 
          valueExpr="value"
          displayExpr="libelle"
          [width]="160">
        </dx-select-box>
  
        <dx-select-box
        *ngIf="getPropertyDataType(config.propertyName) == 'number'"
          [(value)]="config.direction"
          [items]="directionsNumeriques"                                                                                 
          valueExpr="value"
          displayExpr="libelle"
          [width]="160">
        </dx-select-box>
  
        <dx-select-box
        *ngIf="getPropertyDataType(config.propertyName) == 'boolean'"
          [(value)]="config.direction"
          [items]="directionsBoolean"                                                                                 
          valueExpr="value"
          displayExpr="libelle"
          [width]="160">
        </dx-select-box>
        
        <!-- Actions -->
        <dx-button 
          icon="trash"
          type="danger"
          [width]="40"
          (onClick)="supprimerCritere(i)">
        </dx-button>
      </div>
      </dx-sortable>
  </div>

  <!-- Boutons -->
  <div style="margin-top: 20px; display: flex; justify-content: flex-end; gap: 10px;">
    <dx-button 
      text="Réinitialiser"
      type="normal"
      (onClick)="reinitialiserConfiguration()">
    </dx-button>
    <dx-button 
      text="Annuler"
      (onClick)="annulerConfiguration()">
    </dx-button>
    <dx-button 
      text="Valider"
      type="success"
      (onClick)="validerConfiguration()">
    </dx-button>
  </div>

</dx-popup>
